<template>
  <div id="cyber-fitness-component">
    <div class="component cyber-fitness-overview">
        <page-header
        :title="'Cyber Fitness Overview'"
        :links="breadcrumbsLinks"
        ></page-header>
        <div class="card full-width flex-row exercises-section">
            <div class="daily exercise-container">
                <div class="exercise-header">
                <heading class="exercise-title" :level="'h3'">
                    Small Exercise
                </heading>
                <custom-button
                    :text="'List view'"
                    :size="'button-medium'"
                    :type="'achromatic-light'"
                ></custom-button>
                </div>
                <exercise-cards
                    :effortColor="'green'"
                    :effortType="'small'"
                    :titleBody="'SMALL EXERCISE'"
                    :titleFooter="''"
                    :exercises="dailyExercisesToBeDone"
                    :activeExerciseIndex="activeDailyExerciseIndex"
                    :isFetchingData="isFetchingData"
                    :emptyMessage="dailyExercisesEmptyMessage"
                ></exercise-cards>
            </div>
            <div class="monthly exercise-container">
                <div class="exercise-header">
                <heading class="exercise-title" :level="'h3'">
                    Medium Exercise
                </heading>
                <custom-button
                    :text="'List view'"
                    :size="'button-medium'"
                    :type="'achromatic-light'"
                ></custom-button>
                </div>
                <exercise-cards
                    :effortColor="'orange'"
                    :effortType="'medium'"
                    :titleBody="'MEDIUM EXERCISE'"
                    :titleFooter="''"
                    :exercises="monthlyExercisesToBeDone"
                    :activeExerciseIndex="activeMonthlyExerciseIndex"
                    :isFetchingData="isFetchingData"
                    :emptyMessage="monthlyExercisesEmptyMessage"
                ></exercise-cards>
            </div>
        </div>
        <div class="card">
            <div class="card-title">
                <heading :level="'h3'"> Cyber Fitness Leaderboard </heading>
            </div>
            <div class="card-desc">
                <paragraph class="card-desc-title" :type="'p'" :variation="'label'">
                Comparing you to your industry peers that are of a similar size
                </paragraph>
                <div class="leaderboard-chart-wrapper">
                    <div class="leaderboard-chart-with-legends">
                        <paragraph
                            v-if="Object.keys(leaderboardData).length > 0"
                            class="leaderboard-axis-y-title"
                            :type="'p'"
                            :variation="'label'"
                        >
                            Hackability per 1000 services
                        </paragraph>
                        <div class="leaderboard-chart"></div>
                        <div
                            v-if="Object.keys(leaderboardData).length > 0"
                            class="leaderboard-bottom-legends"
                            >
                            <span>
                                <paragraph :type="'p'" :variation="'label'">
                                <i class="green-circle fas fa-circle"></i>
                                Your Hackability Score
                                </paragraph>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-title">
                <div class="card-title-cyber-fitness-progress">
                    <heading :level="'h3'"> Cyber Fitness Progress </heading>
                    <img
                        src="/assets/images/cyber-fitness-progress-config-icon.svg"
                        alt="config-icon"
                    >
                </div>
            </div>
            <div class="card-desc">
                <div class="progress-chart-wrapper">
                    <div class="progress-chart-wrapper">
                    <div class="progress-chart-with-legends">
                        <paragraph
                            v-if="Object.keys(progressData).length > 0"
                            class="progress-axis-y-title"
                            :type="'p'"
                            :variation="'label'"
                            >
                            Hackability per 1000 services
                        </paragraph>
                        <div class="progress-chart"></div>
                        <div
                            v-if="Object.keys(progressData).length > 0"
                            class="progress-bottom-legends"
                            >
                            <span>
                                <paragraph :type="'p'" :variation="'label'" class="grey-text">
                                    Scan date
                                </paragraph>
                            </span>
                        </div>
                        <br />
                        <div
                            v-if="Object.keys(progressData).length > 0"
                            class="progress-bottom-legends"
                            >
                            <span>
                                <paragraph :type="'p'" :variation="'label'">
                                        <i class="green-circle fas fa-circle"></i>
                                        Your Current Score
                                </paragraph>
                            </span>
                            <span>
                                <paragraph :type="'p'" :variation="'label'">
                                        <i class="purple-circle fas fa-circle"></i>
                                        {{ targetProgressLegend }}
                                </paragraph>
                            </span>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */

import {
    find, orderBy, some,
} from 'lodash';
import dayjs from 'dayjs';
import Chartist from 'chartist';
import PageHeader from '~/components/dashboard/components/page-header.vue';
import Paragraph from '~/components/shared/paragraph.vue';
import Heading from '~/components/shared/heading.vue';
import CustomButton from '~/components/shared/custom-button.vue';
import ExerciseCards from '~/components/dashboard/components/exercise-cards.vue';
import {
    cyberFitnessExercises, cyberFitnessLeaderboardProgress,
// eslint-disable-next-line import/extensions
} from './dummy-cyber-fitness.js';

export default {
    name: 'report-cyber-fitness',
    components: {
        PageHeader,
        Paragraph,
        Heading,
        ExerciseCards,
        CustomButton,
    },
    props: {
        scanId: String,
        hasAccessToJira: Boolean,
    },
    data() {
        return {
            cyberFitnessExercises,
            cyberFitnessLeaderboardProgress,
            activeDailyExerciseIndex: 0,
            activeMonthlyExerciseIndex: 0,
            onDetailsTab: false,
            onListTab: false,
            listViewExerciseType: 'daily',
            exercises: [],
            leaderboardData: [],
            progressData: [],
            breadcrumbsLinks: [
                {
                    text: 'Cyber Fitness Dashboard',
                    onClick: () => {
                        this.goToCyberFitnessOverview();
                    },
                },
            ],
            detailsExerciseLink: {
                text: 'Current Exercise',
                onClick: () => {},
            },
            listExerciseLink: {
                text: 'Exercise Overview',
                onClick: () => {
                    this.onDetailsTab = false;
                    if (this.breadcrumbsLinks.length > 2) {
                        this.breadcrumbsLinks.pop();
                    }
                },
            },
            effortColorMapping: {
                1: 'green',
                2: 'orange',
            },
            focusedExerciseOnDetails: {},
            isFetchingData: true,
            fetchingPage: 1,
            paginationCurrentPageNumber: 1,
            paginationPageSize: 5,
            jiraIssueTrackerInDatabase: [],
            ownScore: 0,
            ownProgressScore: 0,
            highestProgressScore: 0,
            intervalProgressScore: 0,
            peerGroupAverageTopQuartile: 0,
            modalState: {
                setFitnessLevel: false,
            },
            targetFitnessLevel: 'top',
            chosenTargetHackabilityScore: null,
        };
    },
    computed: {
        dailyExercises() {
            let filteredExercises = this.exercises.filter((exercise) => exercise.effort < 2 || exercise.hackability_share === 0.0);
            filteredExercises = this.exercises.filter((exercise) => exercise.number_of_affected_hosts <= 20);
            filteredExercises = filteredExercises.sort((exercise1, exercise2) => exercise2.hackability_share - exercise1.hackability_share);
            return filteredExercises;
        },
        dailyExercisesToBeDone() {
            return this.dailyExercises.filter((exercise) => exercise.status === 'To do');
        },
        dailyExercisesEmptyMessage() {
            if (this.dailyExercises.length > 0) {
                return this.getZeroExercisesLeftEmptyMessage('daily');
            }
            return this.getZeroExercisesFoundEmptyMessage('daily');
        },
        monthlyExercises() {
            let filteredExercises = this.exercises.filter((exercise) => ((exercise.effort >= 2 || exercise.number_of_affected_hosts > 20) && exercise.hackability_share !== 0.0));
            filteredExercises = filteredExercises.sort((exercise1, exercise2) => exercise2.hackability_share - exercise1.hackability_share);
            return filteredExercises;
        },
        monthlyExercisesToBeDone() {
            return this.monthlyExercises.filter((exercise) => exercise.status === 'To do');
        },
        monthlyExercisesEmptyMessage() {
            if (this.monthlyExercises.length > 0) {
                return this.getZeroExercisesLeftEmptyMessage('monthly');
            }
            return this.getZeroExercisesFoundEmptyMessage('monthly');
        },
        focusedExercisesOnList() {
            let filteredExercises = [];
            if (this.listViewExerciseType === 'daily') {
                filteredExercises = this.exercises.filter((exercise) => exercise.effort < 2);
                filteredExercises = this.exercises.filter((exercise) => exercise.number_of_affected_hosts <= 20);
                filteredExercises = filteredExercises.sort((exercise1, exercise2) => exercise2.hackability_share - exercise1.hackability_share);
                return filteredExercises;
            }
            filteredExercises = this.exercises.filter((exercise) => (exercise.effort >= 2 || exercise.number_of_affected_hosts > 20));
            filteredExercises = filteredExercises.sort((exercise1, exercise2) => exercise2.hackability_share - exercise1.hackability_share);
            return filteredExercises;
        },
        assignedExercisesInJira() {
            const shortnamesAndAssignee = [];
            this.jiraIssueTrackerInDatabase.forEach((el) => {
                if (el.assignee_display_name) {
                    shortnamesAndAssignee.push({
                        assignee_display_name: el.assignee_display_name,
                        is_closed_in_jira: el.is_closed_in_jira,
                        ticket_key: el.ticket_key,
                        shortnames: el.issue_list.map((issue) => issue.shortname).filter((value, index, self) => self.indexOf(value) === index),
                    });
                }
            });
            return shortnamesAndAssignee;
        },
        progressDataSeries() {
            if (this.progressData) {
                let currentProgressData = this.progressData;
                const series = [];
                const length = currentProgressData.length - 1;
                if (currentProgressData.length > 5) {
                    const orderedRevisions = currentProgressData.sort((firstScan, secondScan) => secondScan.revision - firstScan.revision);

                    const earliestRevision = orderedRevisions.slice(orderedRevisions.length - 1);
                    const fourLatestRevisions = orderedRevisions.slice(0, 4);
                    const trimmedRevisions = earliestRevision.concat(fourLatestRevisions);
                    const orderedTrimmedRevisions = trimmedRevisions.sort((firstScan, secondScan) => firstScan.revision - secondScan.revision);

                    const finalProgressData = [];
                    for (let i = 0; i < orderedTrimmedRevisions.length; i++) {
                        const scan = orderedTrimmedRevisions[i];
                        finalProgressData[i] = scan;
                        finalProgressData[i].revision = i + 1;
                    }
                    currentProgressData = finalProgressData;
                }
                currentProgressData = currentProgressData.sort((firstScan, secondScan) => firstScan.revision - secondScan.revision);
                for (const i in currentProgressData) {
                    const scan = currentProgressData[i];
                    const tempSeries = {
                        data: this.highestProgressAxisY - Math.round(scan.normalized_score),
                        className: length === i ? 'ct-current-scan' : '',
                    };
                    series[i] = tempSeries;
                    if (scan.scan_id === this.scanId) {
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.ownProgressScore = this.highestProgressAxisY - Math.round(scan.normalized_score);
                    }
                }
                const lastTempSeries = {
                    data: this.highestProgressAxisY,
                    className: '',
                };
                return [series];
            }
            return [];
        },
        leaderboardDataSeries() {
            if (this.leaderboardData) {
                const series = [];
                // eslint-disable-next-line no-restricted-syntax
                for (const i in this.leaderboardData) {
                    // eslint-disable-next-line prefer-const
                    let scan = this.leaderboardData[i];
                    if (scan.normalized_score === 0.0) {
                        scan.normalized_score = 1;
                    }
                    const tempSeries = {
                        data: [Math.round(scan.normalized_score)],
                        className: scan.scan_id === this.scanId ? 'ct-current-scan' : '',
                    };
                    series.unshift(tempSeries);
                    if (scan.scan_id === this.scanId) {
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.ownScore = Math.round(scan.normalized_score);
                    }
                }
                return series;
            }
            return [];
        },
        progressLabels() {
            if (this.progressData) {
                const labels = [];
                // eslint-disable-next-line no-restricted-syntax
                // for (const i in this.progressData) {
                //     const scan = this.progressData[i];
                //     const { finished_at } = scan;
                //     const shortDate = dayjs.unix(finished_at).format('DD/MM/YYYY');
                //     labels[i] = shortDate;
                // }
                labels[0] = dayjs.unix(this.progressData[0].finished_at).format('DD/MM/YYYY');
                labels[1] = dayjs.unix(this.progressData[1].finished_at).format('DD/MM/YYYY');
                labels[2] = dayjs.unix(this.progressData[2].finished_at).format('DD/MM/YYYY');
                return labels;
            }
            return [];
        },
        highestProgressAxisY() {
            return this.targetHackabilityScore > this.highestProgressScore ? this.targetHackabilityScore : this.highestProgressScore;
        },
        targetHackabilityScore() {
            return this.chosenTargetHackabilityScore || this.peerGroupAverageTopQuartile;
        },
        targetProgressLegend() {
            return this.chosenTargetHackabilityScore !== null ? 'Your Target Score' : 'Peer Group Average Top Quartile';
        },
    },
    methods: {
        getZeroExercisesLeftEmptyMessage(type) {
            return `<img class="trophy-asset" src="/assets/images/trophy-cyber-fitness.png" alt="success-trophy-cyber-fitness" /><br><br>Congratulations!<br>There are no ${type} exercises left for you.<br>Keep up the good work!`;
        },
        getZeroExercisesFoundEmptyMessage(type) {
            return `Good news!<br><br>Your scan has not discovered any ${type} exercises for you to follow.`;
        },
        toggleSidebarVisibility(value) {
            this.$emit('toggleSidebarVisibility', value);
        },
        setActiveDailyExerciseIndex(newIndex) {
            this.activeDailyExerciseIndex = newIndex;
        },
        setActiveMonthlyExerciseIndex(newIndex) {
            this.activeMonthlyExerciseIndex = newIndex;
        },
        openDetails(clickedExercise) {
            this.focusedExerciseOnDetails = clickedExercise;
            this.toggleSidebarVisibility(false);
            this.breadcrumbsLinks.push(this.detailsExerciseLink);
            this.onDetailsTab = true;
        },
        openListView(exerciseType) {
            this.toggleSidebarVisibility(false);
            this.breadcrumbsLinks.push(this.listExerciseLink);
            this.listViewExerciseType = exerciseType;
            this.paginationCurrentPageNumber = 1;
            this.paginationPageSize = 5;
            this.onListTab = true;
        },
        onPaginationPageChange(currentPage, pageSize) {
            this.paginationCurrentPageNumber = currentPage;
            this.paginationPageSize = pageSize;
        },
        onPaginationSizeChange(currentPage, pageSize) {
            this.paginationCurrentPageNumber = currentPage;
            this.paginationPageSize = pageSize;
        },
        handleActiveIndexOutOfRange() {
            const dailyExercisesToBeDone = this.exercises.filter((exercise) => exercise.effort < 2 && exercise.number_of_affected_hosts <= 20 && exercise.status === 'To do');
            if (this.activeDailyExerciseIndex >= dailyExercisesToBeDone.length) {
                this.activeDailyExerciseIndex = dailyExercisesToBeDone.length - 1;
            }
            const monthlyExercisesToBeDone = this.exercises.filter((exercise) => (exercise.effort >= 2 || exercise.number_of_affected_hosts > 20) && exercise.status === 'To do');
            if (this.activeMonthlyExerciseIndex >= monthlyExercisesToBeDone.length) {
                this.activeMonthlyExerciseIndex = monthlyExercisesToBeDone.length - 1;
            }
        },
        goToCyberFitnessOverview() {
            this.toggleSidebarVisibility(true);
            this.onDetailsTab = false;
            this.onListTab = false;
            this.handleActiveIndexOutOfRange();
            if (this.breadcrumbsLinks.length > 1) {
                this.breadcrumbsLinks.pop();
            }
            this.breadcrumbsLinks.splice(1);
        },
        getExerciseStatus(exercise) {
            if (some(exercise.issues, 'fixed_on')) {
                return 'Done';
            }
            if (some(exercise.issues, 'accepted_on')) {
                return 'Risk-accepted';
            }
            return 'To do';
        },
        groupAffectedServices(exercise) {
            const affectedServices = exercise.issues.reduce((result, issue) => {
                issue.hosts.forEach((host) => {
                    const groupBy = {
                        target: host.target, protocol: host.protocol, port: host.port, service: host.service,
                    };
                    const existingSameService = find(result, groupBy);
                    if (existingSameService) {
                        existingSameService.shortnames.push(host.shortname);
                    } else {
                        const { shortname, ...hostWithoutShortname } = host;
                        const updatedHost = { ...hostWithoutShortname, shortnames: [host.shortname] };
                        result.push(updatedHost);
                    }
                });
                return result;
            }, []);
            return affectedServices;
        },
        getCyberFitnessExercises() {
            this.isFetchingData = true;
            this.cyberFitnessExercises.exercises.forEach((exercise) => {
                const isSmallExercise = exercise.effort < 2 && exercise.number_of_affected_hosts <= 20;
                const tempExercise = {
                    ...exercise,
                    affected_services: this.groupAffectedServices(exercise),
                    color: isSmallExercise ? 'green' : 'orange',
                    cves: exercise.issues.flatMap((issue) => (issue.cves ? issue.cves : [])),
                    effort: isSmallExercise ? 'SMALL' : 'MEDIUM',
                    hackability_share: Math.round(exercise.hackability_share * 10) / 10,
                    selected: false,
                    status: this.getExerciseStatus(exercise),
                    assignee_display_name: '',
                };
                this.exercises.push(tempExercise);
            });
            this.exercises = orderBy(this.exercises, ['effort', 'hackability_share'], ['desc', 'desc']);
            this.isFetchingData = false;
        },
        getCyberFitnessLeaderboardAndProgress() {
            if (this.cyberFitnessLeaderboardProgress.leaderboard) {
                const { leaderboard } = this.cyberFitnessLeaderboardProgress;
                this.leaderboardData = leaderboard;
                // this.scrollToLeaderboardChart();
            }
            if (this.cyberFitnessLeaderboardProgress.progress) {
                const { progress } = this.cyberFitnessLeaderboardProgress;
                this.progressData = progress;
            }
        },
        // scrollToLeaderboardChart() {
        //     const leaderboardChartElement = document.getElementsByClassName('leaderboard-chart-wrapper')[0];
        //     leaderboardChartElement.scrollIntoView({ behavior: 'smooth' });
        // },
        drawProgressGraph() {
            // eslint-disable-next-line prefer-const
            let self = this;
            const { highestProgressAxisY } = this;
            const { targetHackabilityScore } = this;
            const basicOptions = {
                low: 0,
                height: '300px',
                axisX: {
                    offset: 50,
                    showGrid: false,
                },
                axisY: {
                    onlyInteger: true,
                    stretch: false,
                    type: Chartist.FixedScaleAxis,
                    low: 0,
                    high: highestProgressAxisY,
                    ticks: self.createTicks(0, highestProgressAxisY),
                    labelInterpolationFnc(value) {
                        if (highestProgressAxisY === 0) {
                            return Math.round(value);
                        }
                        return Math.round(highestProgressAxisY) - Math.round(value);
                    },
                },
                targetLine: {
                    value: targetHackabilityScore,
                    class: 'ct-target-line',
                    classLabel: 'ct-target-line-label',
                },
            };
            const responsiveOptions = [
                [
                    'screen and (min-width: 1920px)',
                    {
                        seriesBarDistance: 0.025 * window.innerWidth,
                    },
                ],
            ];
            const chart = new Chartist.Line(
                '.progress-chart',
                {
                    labels: this.progressLabels,
                    series: this.progressDataSeries,
                },
                basicOptions,
                responsiveOptions,
            );
            chart.on('created', (context) => {
                const targetLineY = self.projectY(context.chartRect, context.options.targetLine.value);
                context.svg.elem('line', {
                    x1: context.chartRect.x1,
                    x2: context.chartRect.x2,
                    y1: targetLineY,
                    y2: targetLineY,
                }, context.options.targetLine.class);
                context.svg.elem('text', {
                    x: context.chartRect.x1,
                    y: targetLineY,
                }, context.options.targetLine.classLabel);
            });
        },
        drawLeaderboardGraph() {
            const basicOptions = {
                low: 0,
                height: '300px',
                seriesBarDistance: 35,
                axisX: {
                    offset: 50,
                    showGrid: false,
                },
            };
            const responsiveOptions = [
                [
                    'screen and (min-width: 1920px)',
                    {
                        seriesBarDistance: 0.025 * window.innerWidth,
                    },
                ],
            ];
            // eslint-disable-next-line no-new
            new Chartist.Bar(
                '.leaderboard-chart',
                {
                    labels: [
                        'Bottom quartile',
                        'Third quartile',
                        'Second quartile',
                        'Top quartile',
                    ],
                    series: this.leaderboardDataSeries,
                },
                basicOptions,
                responsiveOptions,
            );
        },
        getHighestProgressScore() {
            if (this.progressData) {
                let highestProgressScore = 0;
                // eslint-disable-next-line no-restricted-syntax
                for (const i in this.progressData) {
                    const scan = this.progressData[i];
                    if (Math.round(scan.normalized_score) > highestProgressScore) {
                        highestProgressScore = Math.round(scan.normalized_score);
                    }
                }
                this.highestProgressScore = Math.round(highestProgressScore);
            }
        },
        getchosenTargetHackabilityScoreFromTargetFitnessLevel() {
            return this.calculateAverageQuartileHackabilityScore(this.targetFitnessLevel);
        },
        getPeerGroupAverageTopQuartile() {
            if (this.leaderboardData.length > 0) {
                this.peerGroupAverageTopQuartile = this.calculateAverageQuartileHackabilityScore('top');
            }
        },
        calculateAverageQuartileHackabilityScore(level) {
            const quartileMembers = this.leaderboardData.filter((scan) => scan.quartile === level);
            const sumQuartileHackabilityScore = quartileMembers.reduce((sum, scan) => sum + scan.normalized_score, 0);
            const averageQuartileHackabilityScore = sumQuartileHackabilityScore / quartileMembers.length;
            return Math.round(averageQuartileHackabilityScore);
        },
        calculateAllAverageQuartilesHackabilityScore() {
            const quartilesAverage = {
                top: 0,
                second: 0,
                third: 0,
                bottom: 0,
            };
            Object.keys(quartilesAverage).forEach((level) => {
                quartilesAverage[level] = this.calculateAverageQuartileHackabilityScore(level);
            });
            return quartilesAverage;
        },
        calibrateFitnessLevelVisual() {
            if (this.progressData.length > 0 && this.chosenTargetHackabilityScore) {
                const quartilesAverage = this.calculateAllAverageQuartilesHackabilityScore();
                Object.keys(quartilesAverage).some((level) => {
                    const quartileAverage = quartilesAverage[level];
                    if (this.chosenTargetHackabilityScore <= quartileAverage) {
                        this.targetFitnessLevel = level;
                        return true;
                    }
                    return null;
                });
            }
        },
        getTargetHackabilityScoreFromDatabase() {
            this.calibrateFitnessLevelVisual();
            this.drawProgressGraph();
        },
        createTicks(low, high) {
            if (high === 0) {
                this.intervalProgressScore = 10;
                return [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
            }
            const interval = (high - low) / 10;
            this.intervalProgressScore = interval;
            const ticks = [];
            for (let step = 0; step < 10; step++) {
                ticks.push(step * interval);
            }
            ticks.push(high);
            return ticks;
        },
        projectY(chartRect, value) {
            // eslint-disable-next-line no-mixed-operators
            const coordY = chartRect.y1 - ((this.highestProgressAxisY - value) / this.intervalProgressScore * 23);
            return coordY;
        },
    },
    mounted() {
        this.getCyberFitnessExercises();
        this.getCyberFitnessLeaderboardAndProgress();
        if (this.leaderboardData) {
            this.drawLeaderboardGraph();
        }
        if (this.progressData) {
            this.getHighestProgressScore();
            this.getPeerGroupAverageTopQuartile();
            this.createTicks(0, this.highestProgressAxisY);
            this.$nextTick(() => {
                this.drawProgressGraph();
            });
        }
        this.getTargetHackabilityScoreFromDatabase();
    },
    watch: {
        leaderboardData() {
            this.drawLeaderboardGraph();
        },
        progressData() {
            this.getHighestProgressScore();
            this.getPeerGroupAverageTopQuartile();
            this.createTicks(0, this.highestProgressAxisY);
            this.drawProgressGraph();
            this.calibrateFitnessLevelVisual();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~/scss/pages/signup.scss';


</style>
